import type { StorageLocation, StorageLocationString } from "@/schemas";

export const STORAGE_LOCATION = {
	PACKNET: 0,
	SFTP: 1,
	FIERY: 2,
} as const;

export const normalizeStorageLocation = (value: StorageLocation): StorageLocationString => {
	if (value === "PackNet" || value === "packnet") {
		return "packnet";
	}

	if (value === "sftp" || value === "fiery") {
		return value;
	}

	switch (value) {
		case STORAGE_LOCATION.PACKNET:
			return "packnet";
		case STORAGE_LOCATION.SFTP:
			return "sftp";
		case STORAGE_LOCATION.FIERY:
			return "fiery";
		default:
			return "packnet";
	}
};

export const isStorageLocation = (value: StorageLocation, type: StorageLocationString): boolean => {
	return normalizeStorageLocation(value) === type;
};
